// AuthReducer.js
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from './ActionTypes';

const initialState = {
  isLoggedIn: false,
  user: null,
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      return state;
  }
};

export default AuthReducer;
